import { Object } from "core-js";

export default Object.freeze({
    MissedDelivery: 'Missed a delivery?',
    PreDeliveryRedirection: 'Parcel Redirection',
    PostageRateCalculator: 'Postage Rate Calculator'
});
